<template>
  <div>
    <!-- 活动详情 -->
    <el-drawer :visible.sync="dvisible" :with-header="false" size="70%" :before-close="handleAddClose">
        <el-card shadow="never" class="drawer_body_100">
          <div slot="header" class="clearfix">
            <span>活动详情</span>
          </div>
          <el-form :model="showForm" label-width="auto" size="mini">
            <el-form-item label="活动名称" prop="name">
              <el-input v-model="showForm.activityName"></el-input>
            </el-form-item>
            <el-form-item label="活动备注" prop="bz">
              <el-input type="textarea" v-model="showForm.bz"></el-input>
            </el-form-item>
            <el-form-item label="活动时间" prop="activityDate">
              <el-date-picker
                v-model="showForm.activityDate"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="代金券礼包设置">
              <el-table :data="showForm.activityRule" size="mini">
                <el-table-column prop="couponCount" label="发放券数量" width="120"></el-table-column>
                <el-table-column prop="denomin" label="面额" width="60"></el-table-column>
                <el-table-column prop="second" label="消费次数" width="80">
                  <template slot-scope="scope">
                    {{scope.row.second === -1?'不限次':scope.row.second}}
                  </template>
                </el-table-column>
                <el-table-column prop="quota" label="消费金额门槛" width="100">
                </el-table-column>
                <el-table-column prop="range" label="应用范围" width="100">
                </el-table-column>
                <el-table-column
                  prop="activityDate"
                  label="有效时间">
                  <template slot-scope="scope">
                    <span>{{formatDate(scope.row.startDate)}}</span>
                    <el-divider direction="vertical"></el-divider>
                    <span>{{formatDate(scope.row.endDate)}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="activityDate" label="操作" width="150">
                  <template slot-scope="scope">
                    <el-button v-if="scope.row.range == '指定应用'" @click="handleShowApply(scope.row.applyList)" type="text" size="small">查看应用</el-button>
                    <el-button @click="handleShowModel(scope.row.modelData)" type="text" size="small">查看机型</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
          </el-form>
        </el-card>
    </el-drawer>

    <!-- 查看机型 -->
    <el-dialog title="机型列表" :visible.sync="modelVisible">
      <el-link type="info" v-for="model in modelList"  key="index">【{{model.phoneModel}}】</el-link>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="modelVisible = false">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 查看应用 -->
    <el-dialog title="查看应用" :visible.sync="applyVisible">
      <el-link type="info" v-for="apply in applyList" key="index">【{{apply.applyNo}}{{apply.applyName}}】</el-link>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="applyVisible = false">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PhoneModel from '../phoneModel'
import moment from 'moment'
export default {
  components:{
      'sam-phone-model':PhoneModel
  },
  props: {
    dvisible: Boolean,
    showForm: Object
  },
  data () {
    return {
      applyVisible:false,
      modelVisible:false,
      applyList:[],
      modelList:[],
    }
  },
  created(){

  },
  methods: {
    //抽屉关闭方法
    handleAddClose() {
      this.$parent.handleShowOpenOrClosed();
    },
    formatDate(date) {
      return moment(date).format("YYYY-MM-DD HH:mm");
    },
    handleShowApply(data){
      this.applyList = data;
      this.applyVisible = true;
    },
    handleShowModel(data){
      this.modelList = data;
      this.modelVisible = true;
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/custom/activityShow.vue